import { useRef, useEffect } from 'react';

const DateInput = ({ name, value, onChange, placeholder = 'Date of Birth', style = {} }) => {
  const inputRef = useRef(null);

  // Add native event listener for date picker
  useEffect(() => {
    const input = inputRef.current;
    if (input) {
      const handleClick = (e) => {
        if (input && typeof input.showPicker === 'function') {
          try {
            input.showPicker();
          } catch (err) {
            // If showPicker fails, the default behavior will handle it
          }
        }
      };
      input.addEventListener('click', handleClick);
      return () => {
        input.removeEventListener('click', handleClick);
      };
    }
  }, []);

  const defaultStyle = {
    backgroundColor: 'var(--color-surface)',
    border: '2px solid var(--color-border)',
    color: value ? 'var(--color-text)' : 'transparent',
    width: '100%',
    cursor: 'pointer',
    ...style
  };

  return (
    <div style={{ position: 'relative' }}>
      <input
        ref={inputRef}
        type="date"
        name={name}
        value={value || ''}
        onChange={onChange}
        className="px-4 py-3 theme-input rounded-lg theme-focus"
        style={defaultStyle}
      />
      {!value && (
        <span
          style={{
            position: 'absolute',
            left: '16px',
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            color: '#9ca3af',
            fontSize: '16px',
            userSelect: 'none',
            zIndex: 1
          }}
        >
          {placeholder}
        </span>
      )}
    </div>
  );
};

export default DateInput;



